import { BehaviorSubject, Subject } from 'rxjs';
import { Inject, Injectable } from '@angular/core';
import { BaseService } from '../../../services/base.service';
import { HttpClient } from '@angular/common/http';
import { GroupingState } from '../../../services/crud-table/models/grouping.model';
import { PaginatorState } from '../../../services/crud-table/models/paginator.model';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { ITenderEdit } from '../../../dtos/Tender';
import { TENDER_MODES, TENDER_STATUS } from '../../../constants';
import _ from "lodash";
import { TendersStatus } from '../../../../../../../backend/api-layer/src/core/enums/Tender';

@Injectable({
	providedIn: 'root'
})

export class BuyerNewTenderService<T> extends BaseService<T> {

	currentLanguage: string;

	constructor(
		private translateService: TranslateService,
		@Inject(HttpClient) http
	) {
		super(http);
		this.tableState = {
			filter: {},
			paginator: new PaginatorState(),
			sorting: {
				column: "deadLineDate",
				direction: "desc",
			},
			searchTerm: "",
			grouping: new GroupingState(),
		};
		this.currentLanguage = this.translateService.currentLang;
		this.translateService.onLangChange.subscribe(response => {
			this.currentLanguage = response.lang;
		});
		this.tableState.paginator.pageSize = 10;
	}


	private _products$: BehaviorSubject<any[]> = new BehaviorSubject([]);

    get products$() {
        return this._products$.asObservable();
    }

	set products$(value: any) {
		this._products$.next(value);
	}

	private _productCount$: BehaviorSubject<number> = new BehaviorSubject(0);

    get productCount$() {
        return this._productCount$.asObservable();
    }

	private _privateTenderInfo$: BehaviorSubject<any> = new BehaviorSubject({});

	get privateTenderInfo$() {
		return this._privateTenderInfo$;
	}

	setPrivateTenderInfo(tenderInfo) {
		this._privateTenderInfo$.next(tenderInfo);
	}

	private _tenderStatus$: BehaviorSubject<any> = new BehaviorSubject({});

	get tenderStatus$() {
		return this._tenderStatus$;
	}

	setTenderStatus(tenderInfo) {
		this._tenderStatus$.next(tenderInfo);
	}

	private _selectedProducts$: BehaviorSubject<any> = new BehaviorSubject([]);

	get selectedProducts$() {
		return this._selectedProducts$;
	}

	setSelectedProducts(products) {
		this._selectedProducts$.next(products);
	}

	private _selectedCategory$: BehaviorSubject<any> = new BehaviorSubject({});

	get selectedCategory$() {
		return this._selectedCategory$;
	}

	setSelectedCategory(category) {
		this._selectedCategory$.next(category);
	}

	private _attachments$ = new BehaviorSubject([]);

	get attachments$() {
		return this._attachments$;
	}

	setAttachments(attachments) {
		this._attachments$.next(attachments);
	}

	private _attachmentFiles$ = new BehaviorSubject([]);

	get attachmentFiles$() {
		return this._attachmentFiles$;
	}

	setAttachmentFiles(attachments) {
		this._attachmentFiles$.next(attachments);
	}

	private _productAttachments$ = new BehaviorSubject([]);

	get productAttachments$() {
		return this._productAttachments$;
	}

	setProductAttachments(attachments) {
		this._productAttachments$.next(attachments);
	}

	private _deliveryAddress$: BehaviorSubject<any> = new BehaviorSubject({});

	get deliveryAddress$() {
		return this._deliveryAddress$;
	}

	setDeliveryAddresses(addressData) {
		this._deliveryAddress$.next(addressData);
	}

	private _paymentInfo$: BehaviorSubject<any> = new BehaviorSubject({});

	get paymentInfo$() {
		return this._paymentInfo$;
	}

	setPaymentInfo(paymentData) {
		this._paymentInfo$.next(paymentData);
	}

	private _deadlineData$: BehaviorSubject<any> = new BehaviorSubject({});

	get deadlineData$() {
		return this._deadlineData$;
	}

	setDeadlineData(deadlineData) {
		this._deadlineData$.next(deadlineData);
	}

	private _tenderShortId$: BehaviorSubject<string> = new BehaviorSubject('');

	get tenderShortId$(){
		return this._tenderShortId$.asObservable();
	}

	setTenderShortId(id){
		this._tenderShortId$.next(id);
	}

	private _nullVoumeProduct$ = new BehaviorSubject([]);

	get nullVoumeProduct$() {
		return this._nullVoumeProduct$;
	}

	private message = new Subject<any>();

	sendMessage(message: object) {
		this.message.next(message);
	}
	private _removedAttachmentFiles: Array<any> = [];

	get removedAttachmentFiles() {
		return this._removedAttachmentFiles;
	}

	setRemovedAttachmentFiles(files) {
		this._removedAttachmentFiles=files;
	}

	private _removeRequestLogIdFlag$: BehaviorSubject<boolean> = new BehaviorSubject(false);

	get removeRequestLogIdFlag$() {
		return this._removeRequestLogIdFlag$.asObservable();
	}

	setRemoveRequestLogIdFlag(isRemoveRequestLogIdEnabled: boolean) {
		this._removeRequestLogIdFlag$.next(isRemoveRequestLogIdEnabled);
	}

	private _selectedAIProducts$: BehaviorSubject<any> = new BehaviorSubject([]);

	get selectedAIProducts$() {
		return this._selectedAIProducts$;
	}

	setSelectedAIProducts(products) {
		this._selectedAIProducts$.next(products);
	}

	/*
	* Craete a new draft tender - First call
	*/

	createDraftTender(): Observable<any>{
		const url = this.API_URL + this.VERSION_V1 + this.API_ROUTES.BUYER.TENDERS.CREATE_DRAFT;
		return this.createDraft(url);
	}
	/**
	* Update the current drafted tender
		@param tenderId
		Which is get from local-storage
	*/


	updateDraftTender(tenderId:any): Observable<any> {
		const data=this.prepareDraftTenderData();
		const url = this.API_URL + this.VERSION_V1 + this.API_ROUTES.BUYER.TENDERS.UPDATE_DRAFT+ "/" + tenderId;
		return this.update(url,data,this.currentLanguage);
	}

	updateTender(tenderId:any): Observable<any> {
		const data=this.prepareDraftTenderData();
		const url = this.API_URL + this.VERSION_V1 + this.API_ROUTES.BUYER.TENDERS.EDIT+ "/" + tenderId;
		return this.update(url,data,this.currentLanguage);
	}

	getCurrentTenderDetails(tenderId: string){
		const url =this.API_URL +this.VERSION_V1 +this.API_ROUTES.BUYER.TENDERS.SEARCH +"/" +tenderId + '/find';
		return this.getTenderDetails(url,tenderId);
	}

	/**
	* Publish the current tender
	*/
	publishTender(id){
		const payload={ id };
		const url =this.API_URL +this.VERSION_V1 +this.API_ROUTES.BUYER.TENDERS.PUBLISH_TENDER;
		return this.publishDraftTender(url,payload);
	}

	/**
	 * Check for null product volume data
	 */
	checkForNullEntries(listOfProducts) {
		if (listOfProducts && listOfProducts.length) {
			const nullVolumeProducts = listOfProducts.filter(data => !data.volume);
			this._nullVoumeProduct$.next(nullVolumeProducts);
			return;
		}
		this._nullVoumeProduct$.next([]);
	}
	/**
	* Create form data payload and pass it to the API
	*/

	prepareDraftTenderData() {
		const formData = new FormData();
		if (this._productAttachments$?.getValue()?.length) {
			this._productAttachments$?.getValue()?.forEach((file: any) => {
				if(file.uid){
					formData.append("file", file);
				}
			});
		}

		if (this._attachmentFiles$?.getValue()?.length) {
			this._attachmentFiles$?.getValue()?.forEach((file: any) => {
				if(file.uid){
					formData.append("file", file);
				}
			});
		}

		let data: ITenderEdit = {
			products:this._selectedProducts$?.getValue().map((product) => {
				product["tax"] = product?.tax ? product?.tax : 19;
				product["updatedAt"] = product["updatedAt"] ? product["updatedAt"] : product["createdAt"];
				product["files"] = product["images"];
				return _.omit(product,"__v","id","category","isSelected","alternativeProductId","supplier","similarProductsCount","similarProducts","isFavorite","requestedProduct","images","isEdit","isDraft");
			}),
		};

		if(this._tenderShortId$?.getValue()){
			data['tenderId']=this._tenderShortId$?.getValue();
		}

		data["selectedCategory"] = this._selectedCategory$?.getValue()?.id

		if (!data["selectedCategory"]) {
			data["selectedCategory"] = this._selectedProducts$?.getValue()[0]?.categoryId;
		}

		if (this._privateTenderInfo$?.getValue()) {
			data.isPrivate = this._privateTenderInfo$?.getValue()["tenderMode"] === TENDER_MODES.PRIVATE ? true : false;
			data.invitedEmails = [];
			if (  this._privateTenderInfo$?.getValue()["invitedEmails"] && this._privateTenderInfo$?.getValue()["invitedEmails"].length ) {
				this._privateTenderInfo$?.getValue()["invitedEmails"].forEach((email) => {
					data.invitedEmails.push(email);
				});
			}
			if (this._privateTenderInfo$?.getValue()["tenderMode"] === TENDER_MODES.PRIVATE) {
				data.invitedOrganizations = [];
				if (this._privateTenderInfo$?.getValue()["invitedSuppliers"].length) {
					this._privateTenderInfo$?.getValue()["invitedSuppliers"].forEach(
						(supplier) => {
							data.invitedOrganizations.push(supplier.id);
						}
					);
				}
			}
		}

		const deliveryAddresses = [];
		if(this._deliveryAddress$?.getValue()?.addressInfo && this._deliveryAddress$?.getValue()?.addressInfo?.length) {
			this._deliveryAddress$?.getValue()['addressInfo'].forEach(address => {
				deliveryAddresses.push(address.id);
			});
		}


		if (this._deliveryAddress$?.getValue()?.addressInfo?.length) {
			data.deliveryAddress=deliveryAddresses
		}


		if (this._removedAttachmentFiles?.length) {
			data.removeFiles = this._removedAttachmentFiles;
		}

		if (this._paymentInfo$?.getValue()?.isFormValid) {
			data.paymentInfo1 = this._paymentInfo$?.getValue()["paymentInfo1"];
			data.paymentInfo2 = this._paymentInfo$?.getValue()["paymentInfo2"];
			data.notes = this._paymentInfo$?.getValue()["notes"];
			data.deliveryType=this._paymentInfo$?.getValue()["deliveryType"];
		}

		if (this._deadlineData$?.getValue()?.deadline) {
			data.deadLineDate = this._deadlineData$?.getValue()?.deadline;
			data.name = this._deadlineData$?.getValue()?.title;
			data.description = this._deadlineData$?.getValue()?.description;
			data.activateTenderOn=this._deadlineData$?.getValue()?.activateTenderOn;
		}

		if (this._removeRequestLogIdFlag$?.getValue()) {
			data.removeRequestLogIdFlag = this._removeRequestLogIdFlag$?.getValue();
		}

		formData.append("data", JSON.stringify(data));
		return formData;
	}

	setTenderDataToService(tenderStatus,tender) {
		if(tender && tender['products'].length) {
			tender['products'].forEach(product => {
				if(tenderStatus === 'edit') {
					product['isEdit'] = true;
				}
				if(tenderStatus === 'draft') {
					product['isDraft'] = true;
				}
			});
		}

		this.setPrivateTenderInfo({
			tenderMode: tender['isPrivate'] ? TENDER_MODES.PRIVATE : TENDER_MODES.PUBLIC,
			invitedSuppliers: tender['invitedOrganizationDetails'] ? tender['invitedOrganizationDetails'] : [],
			invitedEmails: tender['invitedEmails'] ? tender['invitedEmails'] : []
		});

		this.setTenderStatus({
			status: tenderStatus,
			tenderId: tender._id ? tender._id : ''
		});

		this.setSelectedProducts(tender['products']);
		this.setRemovedAttachmentFiles([]);
		this.setProductAttachments([]);
		this.setSelectedCategory(tender['products'] && tender['products'][0] ? tender['products'][0].category : {});
		this.setAttachments(tender['attachments'] ? tender['attachments'] : []);
		this.setAttachmentFiles([]);


		let deliveryAddresses = new Set();
		if(tender && tender['deliveryAddress'].length) {
			tender['deliveryAddress'].forEach(address => {
				deliveryAddresses.add(address.id);
			});
		}

		this.setDeliveryAddresses({
			addressInfo: tender['deliveryAddress'] ? tender['deliveryAddress'] : [],
			deliveryAddress: deliveryAddresses
		});

		this.setPaymentInfo({
			notes: tender['notes'] ? tender['notes'] : '',
			paymentInfo1: tender['paymentInfo1'] ? tender['paymentInfo1'] : '',
			paymentInfo2: tender['paymentInfo2'] ? tender['paymentInfo2'] : '',
			deliveryType: tender['deliveryType'] ? tender['deliveryType'] : ''
		});

		this.setDeadlineData({
			deadline: tender['deadLineDate'],
			title: tender['tenderId'] === tender['name'] && tender['status'] === TendersStatus.draft ? '' : tender['name'],
			description: tender['description'],
			activateTenderOn: tender['activateTenderOn']
		});

	}












}
